import type { IAccount } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

type VipAccount = Pick<IAccount, 'planDetails'>;

export const isVipAccount = (account?: VipAccount | null): boolean => (account?.planDetails?.planMRR ?? 0) > 900;

export const VipBadge: React.FC = () => <span className={css(styleSheet.badge)}>VIP</span>;
